import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import HomeIcon from "@mui/icons-material/Home";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Link, useLocation } from "react-router-dom";
import LabelTypography from "../Typography/LabelTypography";
import StoreIcon from "@mui/icons-material/Store";
import { useAuth } from "../../services/AuthServices";
import { MenuContext } from "../../services/MenuService";
import { useContext } from "react";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SystemSecurityUpdateGoodIcon from "@mui/icons-material/SystemSecurityUpdateGood";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import NoteIcon from "@mui/icons-material/Note";
import axios from "axios";
import { Api_Token } from "../../util/Api";
const MenuContainer = styled(Box)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.14), 0 0 1px 0 rgba(0, 0, 0, 0.12)",
  backgroundColor: "#fff",
  display: "flex",
  maxWidth: 263,
  flexDirection: "column",
  fontSize: 8,
  color: "#666",
  fontWeight: 300,
  padding: "24px 16px 64px",
  minHeight: "80vh",
  position: "sticky",
  top: "150px",
  [theme.breakpoints.down("sm")]: {
    fontSize: 6,
    padding: "16px 8px 32px",
  },
}));

const menuItemsByRole = {
  captain: [
    { icon: <HomeIcon />, label: "Dashboard", path: "/dashboard-user" },
    {
      icon: <CheckCircleIcon />,
      label: "Bookings List",
      path: "/bookings",
    },
  ],
  commercial: [
    { icon: <HomeIcon />, label: "Dashboard", path: "/dashboard-user" },
    {
      icon: <CheckCircleIcon />,
      label: "Bookings List",
      path: "/bookings",
    },
  ],
  admin: [
    { icon: <HomeIcon />, label: "Dashboard", path: "/dashboard" },
    { icon: <StoreIcon />, label: "Store", path: "/magasin" },
    { icon: <PersonIcon />, label: "Users", path: "/users" },
    { icon: <NoteIcon />, label: "Check", path: "/check" },
    {
      icon: <SystemSecurityUpdateGoodIcon />,
      label: "Bank transfer",
      path: "/virements",
    },
    { icon: <PersonIcon />, label: "Credit card", path: "/Cart" },
    /*{ icon: <AccountBalanceWalletIcon />, label: "cheque", path: "/check" },
    {
      icon: <SystemSecurityUpdateGoodIcon />,
      label: "virements",
      path: "/virements",
    },
    { icon: <AttachMoneyIcon />, label: "Cart", path: "/Cart" },*/
  ],
};

const getMenuItemsByRole = (role, caisses) => {
  const baseMenu = menuItemsByRole[role] || [];
  if (role === "admin" && caisses.length > 0) {
    const caisseMenu = caisses.map((caisse) => ({
      icon: <AttachMoneyIcon />, // Replace with an appropriate icon
      label:
        caisse.nomCaisse.charAt(0).toUpperCase() + caisse.nomCaisse.slice(1), // Assuming `name` is a property of each `caisse`
      path: `/CaisseJourney/${caisse.id}`, // Assuming each `caisse` has a unique `id`
    }));
    return [...baseMenu, ...caisseMenu];
  }
  return baseMenu;
};
function MenuDashboard() {
  const { user } = useAuth();
  const Role = user?.Role;
  const { MenuPhone, toggleMenuPhone, setMenuPhoneFalse } =
    useContext(MenuContext);
  //  const { MenuPhone } = useSelector((state) => state.style);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const location = useLocation();
  const [caisses, setCaisses] = useState([]);
  useEffect(() => {
    Api_Token.get("caisses/getAll").then((response) => {
      setCaisses(response.data);
    });
  }, []);
  const menuItems = getMenuItemsByRole(Role, caisses);
  const menuList = (
    <>
      {menuItems?.map((item) => {
        const isActive = location.pathname === item.path;
        return (
          <ListItem key={item.label} disablePadding>
            <Link
              to={item.path}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <ListItemButton
                sx={{
                  color: isActive ? "primary.main" : "inherit",
                  fontWeight: isActive ? "bold" : "normal",
                }}
              >
                <ListItemIcon
                  sx={{ color: isActive ? "primary.main" : "inherit" }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={<LabelTypography>{item.label}</LabelTypography>}
                />
              </ListItemButton>
            </Link>
          </ListItem>
        );
      })}
    </>
  );

  return (
    <div>
      {isMobile ? (
        <>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={() => {
              toggleMenuPhone();
            }}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={MenuPhone}
            onClick={() => {
              setMenuPhoneFalse();
            }}
          >
            {menuList}
          </Drawer>
        </>
      ) : (
        <MenuContainer>{menuList}</MenuContainer>
      )}
    </div>
  );
}

export default MenuDashboard;
